import React from "react";
import { ModalHeader } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalHeader";
import { ModalBody } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalBody";
import TokenTransferStep, {
  TokenTransferStepProps,
} from "../../TokenTransferStep";
import TokenTransferConfirmationDetails from "../../TokenTransferConfirmationDetails";
import { useController } from "react-hook-form";
import TokenTransferStepButton from "../../TokenTransferStepButton";
import { TokenTransferRequestFieldNames } from "../../../hooks/constants";

export default function TransferConfirmed({
  isShowing = false,
  onContinue,
  token,
}: TokenTransferStepProps) {
  const {
    field: { value: address },
  } = useController({
    name: TokenTransferRequestFieldNames.walletAddress,
  });

  return (
    <TokenTransferStep isShowing={isShowing}>
      <ModalHeader>Transfer Confirmed!</ModalHeader>

      <ModalBody className="flex flex-col gap-6">
        <TokenTransferConfirmationDetails token={token} address={address} />

        <TokenTransferStepButton onClick={onContinue}>
          Done
        </TokenTransferStepButton>
      </ModalBody>
    </TokenTransferStep>
  );
}
